// extracted by mini-css-extract-plugin
export default {"transactionsHeaderColumn":"Transactions_transactionsHeaderColumn__30lEX","paginationControl":"Transactions_paginationControl__oCcY3"};